'use client';

import { Outlet } from 'react-router-dom';
import { CMORecordsProvider } from '../model/context';

export default function CMORecordsLayout() {
  return (
    <CMORecordsProvider>
      <Outlet />
    </CMORecordsProvider>
  );
}
